import { Injectable } from "@angular/core";
import { LorenBaseEndpointsService } from "../../../../shared/services/loren-base-endpoints-service/loren-base-endpoints.service";
import { LorenAggregate } from "../../../../shared/enums/loren-aggregate.enum";
import { Dayjs } from "dayjs";
import { environment } from "../../../../../environments/environment";
import { Instant } from "@js-joda/core";

@Injectable({
  providedIn: "root",
})
export class LorenReportsEndpointsService extends LorenBaseEndpointsService {
  constructor() {
    super();
  }

  exportNumericData(
    meteringIds: string[],
    dateFrom: Instant,
    dateTo: Instant,
    aggregateTo: LorenAggregate
  ) {
    return `${
      environment.apiServerUrl
    }/reports/numeric-meterings/export?dateFrom=${dateFrom.toString()}&dateTo=${dateTo.toString()}&meteringIds=${meteringIds.join(
      ","
    )}&aggregateTo=${aggregateTo}`;
  }

  exportSoilData(
    meteringIds: string[],
    dateFrom: Dayjs,
    dateTo: Dayjs,
    aggregateTo: LorenAggregate
  ) {
    return `${
      environment.apiServerUrl
    }/reports/moisture?dateFrom=${dateFrom.toISOString()}&dateTo=${dateTo.toISOString()}&meteringIds=${meteringIds.join(
      ","
    )}&aggregateTo=${aggregateTo}`;
  }

  exportBinaryData(meteringIds: string[], dateFrom: Instant, dateTo: Instant) {
    return `${
      environment.apiServerUrl
    }/reports/binary-meterings/export?dateFrom=${dateFrom.toString()}&dateTo=${dateTo.toString()}&meteringIds=${meteringIds.join(
      ","
    )}`;
  }

  exportPresenceData(meteringIds: string[], dateFrom: Instant, dateTo: Instant) {
    return `${
      environment.apiServerUrl
    }/reports/presence-meterings/export?dateFrom=${dateFrom.toString()}&dateTo=${dateTo.toString()}&meteringIds=${meteringIds.join(
      ","
    )}`;
  }

  exportPDFData() {
    return `${environment.apiServerUrl}/reports/asset-meterings/export`;
  }

  exportDevicesReport() {
    return `${environment.apiServerUrl}/reports/client/devices`;
  }

  getSMSNumber() {
    return `${this.getApiServerUrl()}/reports/sms`;
  }
}
